import { render, staticRenderFns } from "./OutsourceDrushimAreas.vue?vue&type=template&id=987d34fa"
import script from "./OutsourceDrushimAreas.vue?vue&type=script&lang=js"
export * from "./OutsourceDrushimAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports